import React from 'react'
import { StyleSheet, View, ViewProps } from 'react-native'

import { Spacing } from '../../style'

import ToastMessage, { ToastInfo } from './message'

const styles = StyleSheet.create({
  container: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 1000,
  },
  content: {
    alignItems: 'flex-end',
    position: 'absolute',
    bottom: Spacing.S,
    right: Spacing.S,
  },
})

export interface Props extends ViewProps {
  messages?: ToastInfo[]
  onClose?: (info: ToastInfo) => void
}
const Toast = (props: Props) => {
  const { messages, onClose, style, ...otherProps } = props

  const close = (info: ToastInfo) => () => {
    onClose && onClose(info)
  }

  return (
    <View style={[styles.container, style]} {...otherProps} pointerEvents="box-none">
      <View style={styles.content}>
        {messages?.map((info) => (
          <ToastMessage key={info.id} info={info} onClose={close(info)} />
        ))}
      </View>
    </View>
  )
}

export default Toast
